<template>
    <div id="home" class="page">

        <div class="menu-openers">
            <!-- <div class="opener" @click="selectedMenu = 'nav'">
                <img class="icon" src="../../assets/images/icons/menu.png" alt="">
            </div> -->
            <div class="opener" @click="openMenu = 'lang'">
                <img class="icon" src="../../assets/images/icons/lang.png" alt="">
            </div>
        </div>

        <Transition name="menu">
            <div class="menu" v-if="openMenu == 'nav'">
                <p class="option" @click="goto('banner')">Banner</p>
                <p class="option" @click="goto('reference')">Reference</p>
                <p class="option" @click="goto('aboutus')">About us</p>
                <p class="option" @click="goto('devices')">Devices</p>
                <p class="option" @click="goto('treasury')">Treasury</p>
                <p class="option" @click="goto('adeo')">Adeo</p>
                <p class="option" @click="goto('partners')">Partners</p>
                <p class="option" @click="goto('online-payments')">Online Payments</p>
                <p class="option" @click="goto('inovative-solutions')">Inovative Solutions</p>
                <p class="option" @click="goto('consultation')">Consultation</p>
                <p class="option" @click="goto('api')">API</p>
            </div>
        </Transition>

        <Transition name="menu">
            <div id="menu-lang" class="menu" v-if="openMenu == 'lang'">
                <p class="option" :class="selectedLanguage == 'hr' ? 'selected' : ''" @click="changeLanguage('hr')"><img class="icon" src="../../assets/images/flags/CRO.png" alt="missing flag">Hrvatski</p>
                <p class="option" :class="selectedLanguage == 'en' ? 'selected' : ''" @click="changeLanguage('en')"><img class="icon" src="../../assets/images/flags/ENG.png" alt="missing flag">English</p>
                <p class="option" :class="selectedLanguage == 'sl' ? 'selected' : ''" @click="changeLanguage('sl')"><img class="icon" src="../../assets/images/flags/SLO.png" alt="missing flag">Slovenski</p>
            </div>
        </Transition>

        <SectionBanner />
        <SectionReference />
        <SectionAboutus />
        <SectionDevices />
        <SectionTreasury />
        <SectionPartners />
        <SectionOnlinePayment />
        <SectionConsultation />
        <SectionApi />

        <footer id="footer" class="footer" ref="footer">

            <div class="info-stack fundings">
                <div class="info-line">
                    <span class="header">{{ $t("footer.funding.header") }}</span>
                </div>
                <div class="info-line">
                    <div class="info">
                        <p>{{ $t("footer.funding.info") }}</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="image-row">
                        <img src="../../assets/images/fundings/esif.png" alt="">
                        <img src="../../assets/images/fundings/hamag.png" alt="">
                    </div>
                </div>
            </div>

            <div class="info-stack address">
                <div class="info-line">
                    <span class="header">M obrada d.o.o.</span>
                </div>
                <div class="info-line">
                    <div class="info">
                        <p>Društvo s ograničenom odgovornošću za trgovinu i usluge.</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <p>Trgovačko društvo upisano je u Sudski registar Trgovačkog suda u Zagrebu.</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <p>MBS: 080986441</p>
                        <p>OIB: 73699054684</p>
                        <p>MB: 4427831</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <p>{{ $t("footer.company-info.base-capital") }}</p>
                        <br>
                        <p>{{ $t("footer.company-info.bank") }}</p>
                        <p>IBAN: HR0324080021100058262</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <span>{{ $t("footer.company-info.hanfa-1") }}</span>
                        <a href="https://www.hanfa.hr/registri/virtualne-valute/pravni-subjekti-pruzatelji-usluga-virtualne-imovine/"> HANFA Registar </a>
                        <span>{{ $t("footer.company-info.hanfa-2") }}</span>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <span>{{ $t("footer.company-info.register-1") }}</span>
                        <a href="https://www.hnb.hr/documents/d/guest/h-registar-pruzatelja-platnih-usluga-i-izdavatelja-e-novca-pdf" target="_blank"> {{ $t("footer.company-info.register-link") }} </a>
                        <span>{{ $t("footer.company-info.register-2") }}</span>
                    </div>
                </div>
            </div>

            <div class="info-stack contacts">
                <div class="info-line">
                    <span class="header">{{ $t("footer.contacts.header") }}</span>
                </div>
                <div class="info-line">
                    <div class="icon-holder">
                        <img class="icon" src="../../assets/images/icons/envelope.png" alt="">
                    </div>
                    <div class="info">
                        <a href="mailto:info@m2pay.solutions">info@m2pay.solutions</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="icon-holder">
                        <img class="icon" src="../../assets/images/icons/map-marker.png" alt="">
                    </div>
                    <div class="info">
                        <p>Ul. Grada Vukovara 271, 10000 Zagreb</p>
                    </div>
                </div>
                <div class="info-line">
                    <div class="icon-holder">
                        <img class="icon" src="../../assets/images/icons/phone.png" alt="">
                    </div>
                    <div class="info">
                        <p>Prodaja</p>
                        <a href="callto:+385916327297">+385 91 6327 297</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="icon-holder">
                        <img class="icon" src="../../assets/images/icons/phone.png" alt="">
                    </div>
                    <div class="info">
                        <p>Korisnička podrška</p>
                        <a href="callto:+38540321310">+385 40 321 310</a>
                    </div>
                </div>

            </div>

            <div class="info-stack links">
                <div class="info-line">
                    <span class="header">{{ $t("footer.links.header") }}</span>
                </div>
                <div class="info-line">
                    <div class="info">
                        <!-- <a href="https://m2pay.solutions/wp-content/uploads/2024/10/M2PAY-op%C4%87i-uvjeti-poslovanja-1.11.2024..pdf">{{ $t("footer.links.links.conditions") }}</a> -->
                        <a href="../../assets/pdfs/terms.pdf" target="_blank">{{ $t("footer.links.links.conditions") }}</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <!-- <a href="https://m2pay.solutions/wp-content/uploads/2024/10/Cjenik-M2PAY-1.11.2024.pdf">{{ $t("footer.links.links.menu") }}</a> -->
                         <a href="../../assets/pdfs/price-menu.pdf" target="_blank">{{ $t("footer.links.links.menu") }}</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <!-- <a href="https://m2pay.solutions/wp-content/uploads/2025/03/Kratke-upute-za-korištenje-PAX-A920-web.pdf">{{ $t("footer.links.links.instructions") }}</a> -->
                         <a href="../../assets/pdfs/user-manual.pdf" target="_blank">{{ $t("footer.links.links.instructions") }}</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <!-- <a href="https://m2pay.solutions/wp-content/uploads/2025/03/Kratke-upute-za-korištenje-PAX-A920-web.pdf">{{ $t("footer.links.links.instructions") }}</a> -->
                         <a href="../../assets/pdfs/privacy-policy.pdf" target="_blank">{{ $t("footer.links.links.privacy-policy") }}</a>
                    </div>
                </div>

                <div class="info-line">
                    <div class="info">
                        <a href="https://documenter.getpostman.com/view/22972506/2sAXqwYzuo">ECR API</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <a href="https://documenter.getpostman.com/view/22972506/2sAXjNWq6w">Billing API</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <a href="https://documenter.getpostman.com/view/22972506/2sAXxJhaDm">Crypto API</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                        <a href="https://developer-ecomm.handpoint.com/docs/overview">E-commerce API</a>
                    </div>
                </div>
                <div class="info-line">
                    <div class="info">
                         <a href="../../../assets/pdfs/privola-emp.pdf" target="_blank">{{ $t("footer.links.links.privacy-policy-emp") }}</a>
                    </div>
                </div>
            </div>

        </footer>

        <p class="copyright-line">Copyright © 2025 M2PAY | All Rights Reserved</p>

    </div>
</template>

<script>
    import SectionBanner from "./sections/section-banner.vue";
    import SectionReference from "./sections/section-reference.vue";
    import SectionAboutus from "./sections/section-aboutus.vue";
    import SectionDevices from "./sections/section-devices.vue";
    import SectionTreasury from "./sections/section-treasury.vue";
    import SectionPartners from "./sections/section-partners.vue";
    import SectionOnlinePayment from "./sections/section-online-payment.vue";
    import SectionConsultation from "./sections/section-consultation.vue";
    import SectionApi from "./sections/section-api.vue";

    export default {
        components: {
            SectionBanner,
            SectionReference,
            SectionAboutus,
            SectionDevices,
            SectionTreasury,
            SectionPartners,
            SectionOnlinePayment,
            SectionConsultation,
            SectionApi
        },

        data() {
            return {
                openMenu: "",
                selectedLanguage: ""
            }
        },

        mounted() {
            let lang = localStorage.getItem("selected_language");
            if (!lang) localStorage.setItem("selected_language", "hr");
            this.selectedLanguage = lang;
        },

        methods: {
            scrollToElement(ref) {
                const el = ref;

                if (el) {
                    el.scrollIntoView({behavior: 'smooth'});
                }
            },

            changeLanguage(language) {
                this.openMenu = "";
                localStorage.setItem("selected_language", language);
                this.selectedLanguage = language;
                this.$i18n.locale = language;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #home {
        .menu-openers {
            display: flex;
            flex-direction: column;
            z-index: 99;
            position: absolute;
            right: 0;

            .opener {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 20px;
                margin-right: 40px;
                border-radius: 3px;
                width: 50px;
                height: 50px;
                background-color: var(--signature);
                cursor: pointer;
                transition: 1s;

                &:hover {
                    scale: 1.1;
                    background-color: var(--hover);
                }

                .icon {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .footer {
            display: flex;
            justify-content: space-evenly;
            flex-wrap: wrap;
            width: 100%;
            padding: 50px 5%;
            background-color: #222;
            color: #fff;

            .info-stack {
                display: flex;
                flex-direction: column;
                width: 300px;
                margin-bottom: 50px;

                &.fundings {
                    
                }
    
                &.address {
                    
                }
    
                &.contacts {
                    
                }
    
                &.links {
                    
                }
                
                .info-line {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    width: 100%;

                    .header {
                        margin-bottom: 10px;
                        font-weight: bold;
                        color: #fff;
                    }

                    .icon-holder {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 10px;
                        border-radius: 50%;
                        width: 35px;
                        height: 35px;
                        background-color: #333;

                        .icon {
                            height: 20px;
                        }
                    }
                    
                    .info {
                        // display: flex;
                        // flex-direction: column;
                        
                        span, p {
                            color: #fff;
                        }
                    }

                    .image-row {
                        // display: flex;
                        // flex-direction: column;

                        img {
                            // height: 100px;
                            width: 100%;
                        }
                    }
                }
            }
        }

        .copyright-line {
            width: 100%;
            padding: 8px 5%;
            color: #fff;
            background-color: #222;
        }
    }
</style>